export default __webpack_public_path__ + "static/media/no_services.cb566d85.svg";